import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import React from "react";
import { CustomTable, SearchTableInput } from "../../../components";
import PodModal from "./PodModal";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { podTableHeading } from "../../../assets/lib/pod";

const customStyle = makeStyles({
  root: {
    padding: "20px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  buttonContainer: {
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
  },
  actionBtn: {
    display: "flex",
    gap: "30px",
  },
  '@media (max-width: 390px)': {
    root: {
      padding: "5px 5px", 
      gap: "60px", 
      width:"80vw",
    },
    buttonContainer: {
      height: "35px",
      justifyContent: "left",
      flexWrap: "wrap",
    },
    actionBtn: {
      marginTop:"5px",
      marginLeft:"-2px",
      gap: "5px",
      flexDirection: "row", 
      height: "35px",
      width:"75vw"
    },
  },
});

const Layout = (props) => {
  const {
    podTableData,
    fetchPodNumber,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    isModalOpen,
    setIsModalOpen,
    handleSubmitModal,
    podState,
    getPodInput,
    errorFields,
    loadingModal,
    campusData,
    campusMenu,
    setCampusMenu,
    vendorData,
    vendorMenu,
    setVendorMenu,
    actions,
  } = props;
  const classes = customStyle();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      <div className={classes.buttonContainer} >
        <SearchTableInput
          tableHeading={podTableHeading}
          handleSearchQuery={handleSearchQuery}
        />
        <div className={classes.actionBtn}>
          <Button
            variant="contained"
            style={{
              color: "white",
              backgroundColor: "#FF5722",
              padding: "12px 24px",
              borderRadius: "10px",
            }}
            onClick={() => {
              setIsModalOpen(true);
              fetchPodNumber();
            }}
          >
            Add Pod
          </Button>
          <Button
            variant="contained"
            style={{
              color: "white",
              backgroundColor: "#FF5722",
              padding: "12px 24px",
              borderRadius: "10px",
            }}
            onClick={() => navigate(routes.MANAGE_PODS)}
          >
            Manage Pods
          </Button>
        </div>
      </div>
      <div className="table">
      <CustomTable
        columns={podTableHeading}
        data={podTableData}
        actions={actions}
        isLoading={isTableLoading}
        currentPage={currentPage}
        totalLength={totalLength}
        handlePageChange={handlePageChange}
        handlePageSize={handlePageSize}
        handleTableSorting={handleTableSorting}
      />
      </div>
      <PodModal
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        handleSubmitModal={handleSubmitModal}
        podState={podState}
        getPodInput={getPodInput}
        errorFields={errorFields}
        loadingModal={loadingModal}
        campusData={campusData}
        campusMenu={campusMenu}
        setCampusMenu={setCampusMenu}
        vendorData={vendorData}
        vendorMenu={vendorMenu}
        setVendorMenu={setVendorMenu}
      />
    </div>
  );
};

export default Layout;
